import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import { 
  REQUEST_DETAIL_ECO_LIST,
  REQUEST_DETAIL_ECO_SEARCH_GEO_COUNTRY_LIST,
  REQUEST_DETAIL_ECO_SEARCH_HEALTH_AGENCY_LIST,
  REQUEST_DETAIL_ECO_ADD,
  REQUEST_DETAIL_ECO_DETAIL,
  REQUEST_DETAIL_ECO_UPDATE,
} from '../actions';
import {
  RequestDetailEcoListSuccess,
  RequestDetailEcoListError,
  RequestDetailEcoSearchGeoCountryListSuccess,
  RequestDetailEcoSearchGeoCountryListError,
  RequestDetailEcoSearchHealthAgencyListSuccess,
  RequestDetailEcoSearchHealthAgencyListError,
  RequestDetailEcoAddSuccess,
  RequestDetailEcoAddError,
  RequestDetailEcoDetailSuccess,
  RequestDetailEcoDetailError,
  RequestDetailEcoUpdateSuccess,
  RequestDetailEcoUpdateError
} from '../actions';
 
export function* watchRequestDetailEcoList() {
  yield takeEvery(REQUEST_DETAIL_ECO_LIST, onRequestDetailEcoList);
}

export function* watchRequestDetailEcoSearchHealthAgencyList() {
  yield takeEvery(REQUEST_DETAIL_ECO_SEARCH_HEALTH_AGENCY_LIST, onRequestDetailEcoSearchHealthAgencyList);
}

export function* watchRequestDetailEcoSearchGeoCountryList() {
  yield takeEvery(REQUEST_DETAIL_ECO_SEARCH_GEO_COUNTRY_LIST, onRequestDetailEcoSearchGeoCountryList);
}

export function* watchRequestDetailEcoAdd() {
  yield takeEvery(REQUEST_DETAIL_ECO_ADD, onRequestDetailEcoAdd);
}

export function* watchRequestDetailEcoDetail() {
  yield takeEvery(REQUEST_DETAIL_ECO_DETAIL, onRequestDetailEcoDetail);
}

export function* watchRequestDetailEcoUpdate() {
  yield takeEvery(REQUEST_DETAIL_ECO_UPDATE, onRequestDetailEcoUpdate);
}

const onRequestDetailEcoListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request_detail_eco/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onRequestDetailEcoUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request_detail_eco/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}


const onRequestDetailEcoAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request_detail_eco/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onRequestDetailEcoSearchGeoCountryListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/geo_country', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onRequestDetailEcoSearchHealthAgencyListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/health_agency', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onRequestDetailEcoDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request_detail_eco/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

function* onRequestDetailEcoList(data) {
  try {
    const response = yield call(onRequestDetailEcoListAsync, data.payload);
    yield put(RequestDetailEcoListSuccess(response.data));
  } catch (error) {
    yield put(RequestDetailEcoListError(error));
  }
}

function* onRequestDetailEcoSearchHealthAgencyList(data) {
  try {
    const response = yield call(onRequestDetailEcoSearchHealthAgencyListAsync, data.payload);
    yield put(RequestDetailEcoSearchHealthAgencyListSuccess(response.data));
  } catch (error) {
    yield put(RequestDetailEcoSearchHealthAgencyListError(error));
  }
}

function* onRequestDetailEcoSearchGeoCountryList(data) {
  try {
    const response = yield call(onRequestDetailEcoSearchGeoCountryListAsync, data.payload);
    yield put(RequestDetailEcoSearchGeoCountryListSuccess(response.data));
  } catch (error) {
    yield put(RequestDetailEcoSearchGeoCountryListError(error));
  }
}

function* onRequestDetailEcoAdd(data) {
  try {
      const response = yield call(onRequestDetailEcoAddAsync, data);
      console.log(response)
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(RequestDetailEcoAddSuccess(response.data));
  } catch (error) {
      yield put(RequestDetailEcoAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onRequestDetailEcoDetail(data) {
  try {
    const response = yield call(onRequestDetailEcoDetailAsync, data.payload);
    yield put(RequestDetailEcoDetailSuccess(response.data.data));
  } catch (error) {
    yield put(RequestDetailEcoDetailError(error));
  }
}

function* onRequestDetailEcoUpdate(data) {
  try {
      const response = yield call(onRequestDetailEcoUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(RequestDetailEcoUpdateSuccess(response.data));
  } catch (error) {
      yield put(RequestDetailEcoUpdateError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchRequestDetailEcoList),
    fork(watchRequestDetailEcoSearchGeoCountryList),
    fork(watchRequestDetailEcoSearchHealthAgencyList),
    fork(watchRequestDetailEcoAdd),
    fork(watchRequestDetailEcoDetail),
    fork(watchRequestDetailEcoUpdate),
  ]);
} 